import styles from "./styles.scss";

import clsx from "clsx";
import { forwardRef, type PropsWithChildren } from "react";

import type { SwitchButtonProps } from "./types";

export const SwitchButton = forwardRef<
  HTMLInputElement,
  PropsWithChildren<SwitchButtonProps>
>(({ className, name, ...props }, ref) => {
  return (
    <label className={clsx(styles.labelRegular, className)}>
      <input
        className={clsx(styles.hiddenInput, styles.switchCheckbox)}
        type="checkbox"
        ref={ref}
        {...props}
      />

      <span className={styles.switchButton} />
      <span className={styles.switchLabel} />

      {!!name && <span>{name}</span>}
    </label>
  );
});
